'use strict';

var DashboardScheduleTransformerFactory = function DashboardScheduleTransformerFactory(DataTransformer) {
  function DashboardScheduleTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'market-dashboard';
    this.targetType = 'dashboard-schedule';
    this.priority = 1;
  }
  DashboardScheduleTransformer.prototype = Object.create(DataTransformer.prototype);
  DashboardScheduleTransformer.constructor = DashboardScheduleTransformer;
  DashboardScheduleTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DashboardScheduleTransformer.prototype.isCacheable = function () {
    return true;
  };
  DashboardScheduleTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  DashboardScheduleTransformer.prototype.transform = function (data, metrics, metricDescriptor) {
    if (data.domain._embedded && data.domain._embedded.marketMonthMetrics) {
      data = data.domain._embedded.marketMonthMetrics;
      var transformed = [];
      var dimension = metricDescriptor.dimension.toLocaleUpperCase();
      for (var index = 0, dataLength = data.length; index < dataLength; index++) {
        var element = data[index];

        //we have to dimensions : REGULAR and MAPPED
        if (dimension !== element.flowType) {
          continue;
        }
        var pos = {};
        for (var posIndex = 0, posLength = element.pointOfSales.length; posIndex < posLength; posIndex++) {
          pos[element.pointOfSales[posIndex].posName] = true;
        }
        transformed.push({
          month: element.month - 1,
          market: element.origin + '-' + element.destination,
          scheduleChange: element.scheduleChange,
          pos: Object.keys(pos)
        });
      }
      return transformed;
    } else {
      return [];
    }
  };
  return DashboardScheduleTransformer;
};
DashboardScheduleTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = DashboardScheduleTransformerFactory;